export enum DATA_QA {
	NEWS_FORGE_WRAPPER = 'news-forge-wrapper',
	NEWS_FORGE_URL_LINK = 'news-forge-url-link',
	NEWS_FORGE_CATEGORY_SELECT = 'news-forge-category-select',
	NEWS_FORGE_EXTRACT_AND_TRANSLATE_BUTTON = 'news-forge-extract-and-translate-button',
	NEWS_FORGE_EXTRACT_AND_CLEAR_BUTTON = 'news-forge-clear-button',
	NEWS_FORGE_OPERATIONS_CONTAINER = 'news-forge-operations-container',
	NEWS_FORGE_TEXT_CONTAINER = 'news-forge-text-container',
	NEWS_FORGE_ORIGINAL_CONTENT_CONTAINER = 'news-forge-original-content-container',
	NEWS_FORGE_TRANSLATED_CONTENT_CONTAINER = 'news-forge-translated-content-container',
	NEWS_FORGE_CHAR_AND_WORDS_COUNTER = 'news-forge-char-and-words-counter',
	NEWS_FORGE_REGENERATE_TEXT_BUTTON = 'news-forge-regenerate-text-button',
	NEWS_FORGE_CREATE_ARTICLE_BUTTON = 'news-forge-create-article-button',
	NEWS_FORGE_CREATED_ARTICLE_MODAL = 'news-forge-created-article-modal',
}
